// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ItemListIcon__itemList___2F89V","inner":"ItemListIcon__inner___Nbjh3"};